export default __webpack_public_path__ + "static/media/disconnected from launch.f69cb843.svg";